import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddControl from 'components/add_control/v2';

import Row from './row';
import ScheduleModal from './modal';

export function ScheduleTable({ isParentCompanyUser, royaltySchedules }) {
  const [showModal, setShowModal] = useState();

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex justify-content-between align-items-center gap-2">
        <h5>Royalty Schedule (Sale / Lease / Other)</h5>
        {isParentCompanyUser &&
          <AddControl label="Add royalty Schedule" name="add-schedule" onClick={() => setShowModal(true)} />
        }
      </div>

      <div className="table-container">
        <table className="table"t>
          <thead>
            <tr>
              {isParentCompanyUser &&
                <React.Fragment>
                  <th>Name</th>
                  <th>Royalty Pattern Name</th>
                </React.Fragment>}
              <th className="text-center">Tiers</th>
              <th className="text-center"># Agents</th>
              <th className="text-center"># Agents Paid</th>
              <th className="text-end">YTD Gross Commission</th>
              <th className="text-end">Current Tier</th>
              {isParentCompanyUser &&
                <React.Fragment>
                  <th className="text-center">Last Updated</th>
                  <th/>
                </React.Fragment>
              }
            </tr>
          </thead>

          <tbody>
            {royaltySchedules
              .filter(royaltySchedule => isParentCompanyUser || royaltySchedule.companyDefault)
              .map(royaltySchedule => (
                <Row
                  isParentCompanyUser={isParentCompanyUser}
                  key={royaltySchedule.id}
                  royaltySchedule={royaltySchedule}
                />
              ))}
          </tbody>
        </table>
      </div>

      <ScheduleModal show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}

ScheduleTable.propTypes = {
  isParentCompanyUser: PropTypes.bool,
  royaltySchedules: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })),
};

const mapStateToProps = ({ isParentCompanyUser, royaltySchedules }) => ({
  isParentCompanyUser,
  royaltySchedules: royaltySchedules.schedules,
});

export default connect(mapStateToProps)(ScheduleTable);
